import { Component } from '@angular/core';

@Component({
  selector: 'mlc-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
}
